/**
 * @fileoverview Utility functions for the courses menu.
 * This file contains functions that determine whether to show certain links
 * based on the region, permissions, and request information.
 * It also contains a function to determine if a menu is 3-tier.
 */
import {PermissionsInfo, RequestInfo} from "@khan/shared-core";

import type {DomainLink, DomainObject} from "../types.ts";

export const shouldShowStandardsGuidesLink = (
    region,
    shouldRenderStandardsGuideLink,
): boolean => {
    return (
        !!shouldRenderStandardsGuideLink &&
        region.status === "success" &&
        region.regionCode.toUpperCase().startsWith("US") &&
        RequestInfo.kaLocale === "en"
    );
};

export const shouldShowKhanmigoLink = (): boolean => {
    return (
        !PermissionsInfo.isLoggedIn &&
        RequestInfo.kaLocale === "en" &&
        RequestInfo.remoteCountry === "US"
    );
};

// Returns true if all children are Domain Objects and all grandchildren are Domain Links
export const is3Tier = (
    children: Array<DomainObject | DomainLink>,
): children is Array<DomainObject> => {
    return children.every((child) => {
        // Check if child is a DomainObject
        if (!("children" in child)) {
            return false;
        }
        // Check if every grandchild is a DomainLink
        if (Array.isArray(child.children)) {
            return (child.children as DomainLink[]).every(
                (grandchild) => !("children" in grandchild),
            );
        }
    });
};
